import React, { useState, useEffect } from 'react';
import { ComposedChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const WaQualityBadge = () => {
  const [q, setQ] = useState(null);
  useEffect(() => {
    fetch(`${API_URL}/api/admin/wa-quality`)
      .then(r => r.json()).then(setQ).catch(() => {});
  }, []);
  if (!q || !q.customer_channel || !q.customer_channel.quality_rating) return null;
  const rating = String(q.customer_channel.quality_rating).toUpperCase();
  const tier = q.customer_channel.messaging_limit_tier || '';
  const map = {
    GREEN: ['bg-green-100 text-green-800 border-green-300', '🟢 GREEN — सुरक्षित'],
    YELLOW: ['bg-yellow-100 text-yellow-800 border-yellow-300', '🟡 YELLOW — सावधान, msg volume घटाएं'],
    RED: ['bg-red-100 text-red-800 border-red-300', '🔴 RED — Ban खतरा! Automation रोकें'],
  };
  const [cls, label] = map[rating] || ['bg-gray-100 text-gray-700 border-gray-300', `⚪ ${rating}`];
  return (
    <div className={`mb-4 px-4 py-2.5 rounded-xl border-2 flex items-center justify-between flex-wrap gap-2 ${cls}`} data-testid="wa-quality-badge">
      <span className="text-sm font-bold">📱 WhatsApp Number Quality: {label}</span>
      {tier && <span className="text-xs font-semibold opacity-75">Limit tier: {tier.replace('TIER_', '')}/day</span>}
    </div>
  );
};

export const WeeklyChart = () => {
  const [data, setData] = useState([]);
  useEffect(() => {
    fetch(`${API_URL}/api/admin/analytics/weekly`)
      .then(r => r.json()).then(d => setData(d.days || [])).catch(() => {});
  }, []);
  if (!data.length) return null;
  const totalAmount = data.reduce((s, d) => s + (d.amount || 0), 0);
  return (
    <div className="mb-4 p-3 rounded-xl bg-white border border-gray-200 shadow-sm" data-testid="weekly-analytics-chart">
      <div className="flex items-center justify-between mb-2 flex-wrap gap-2">
        <span className="text-sm font-bold text-gray-700">📊 7 दिन — Leads vs Payments</span>
        <span className="px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 text-xs font-bold" data-testid="weekly-total-amount">सप्ताह की कमाई: ₹{totalAmount}</span>
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <ComposedChart data={data} margin={{ top: 5, right: 10, left: -15, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
          <XAxis dataKey="date" tick={{ fontSize: 11 }} />
          <YAxis allowDecimals={false} tick={{ fontSize: 11 }} />
          <Tooltip formatter={(v, n) => n === 'leads' ? [v, 'Leads'] : [v, 'Payments']}
            labelStyle={{ fontWeight: 700 }} />
          <Legend formatter={(v) => v === 'leads' ? 'Leads' : 'Payments'} />
          <Bar dataKey="leads" fill="#2563eb" radius={[4, 4, 0, 0]} />
          <Bar dataKey="payments" fill="#059669" radius={[4, 4, 0, 0]} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
};
